import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import routes from './routes'

import jwtService from '../services/jwtService'

import { CHECK_AUTH } from '../store/actions.type'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior (to) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  to.meta.layout = to.meta.layout || 'DefaultLayout'
  store.dispatch('setLayout', to.meta.layout)
  store.dispatch(CHECK_AUTH)

  let tenantCode = ''
  if (to.params.tenantCode) {
    tenantCode = to.params.tenantCode
  }
  store.dispatch('setTenantCode', tenantCode)

  if (to.matched.some(record => record.meta.needAuth)) {
    if (jwtService.getToken()) {
      next()
      return
    }

    next('/' + tenantCode)
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js